import 'picturefill';
import 'lazysizes';
import 'core-js/es/object/assign';
//import { getTwitterCount, getFacebookCount } from './modules/sns-count'
import MoveTo from 'moveto';
const moveTo = new MoveTo();
import React from 'react';
import { render } from 'react-dom';
import Index from '@react/index';
window.addEventListener('DOMContentLoaded', () => {
    render(React.createElement(Index, null), document.getElementById('root'));
    // トップへ戻るの初期化
    const scrolltoTop = document.querySelector('.js-scrollto-top');
    if (scrolltoTop !== null) {
        scrolltoTop.addEventListener('click', () => {
            moveTo.move(document.body);
        });
    }
});
/**
 * SNSカウントの初期化
window.addEventListener('load', async () => {
  // それぞれのカウント数を取得
  const twitterCount = await getTwitterCount('http://schoolgirlstrikers.jp/7thAniv/')
  const facebookCount = await getFacebookCount('http://schoolgirlstrikers.jp/7thAniv/')

  setSNSCount('js-twitter-count', twitterCount)
  setSNSCount('js-facebook-count', facebookCount)
})

const setSNSCount = (id: string, count: number): void => {
  const el = document.getElementById(id) as HTMLElement
  if (el) {
    el.innerHTML = count.toString()
  }
}
 */ 
